export const buildTitle = (data) => ((data.number ? (data.number + ". ") : "") + data.title) || 'Задача';
